
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agreements/terms-of-use",
      function () {
        return require("private-next-pages/agreements/terms-of-use.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agreements/terms-of-use"])
      });
    }
  